import {DateTime} from "luxon";

export function formatDateTimeShort(date: DateTime | undefined) {
  if (!date) {
    return '';
  }
  return date.toLocaleString(DateTime.DATETIME_SHORT)
}

export function formatDateShort(date: DateTime | undefined) {
  if (!date) {
    return '';
  }
  return date.toLocaleString(DateTime.DATE_SHORT)
}

export function formatDateMedium(date: DateTime | undefined) {
  if (!date) {
    return '';
  }
  return date.toLocaleString(DateTime.DATE_MED)
}

export function parseDate(dateStr: string | DateTime | undefined): DateTime | undefined {
  if(!dateStr) {
    return undefined
  }
  return DateTime.fromISO(dateStr.toString())
}
